var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavdots({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 19,
    viewBox: "0 0 4 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 18,
    transform: "translate(0 0.566406)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 0.566406C0.9 0.566406 0 1.46641 0 2.56641C0 3.66641 0.9 4.56641 2 4.56641C3.1 4.56641 4 3.66641 4 2.56641C4 1.46641 3.1 0.566406 2 0.566406ZM2 14.5664C0.9 14.5664 0 15.4664 0 16.5664C0 17.6664 0.9 18.5664 2 18.5664C3.1 18.5664 4 17.6664 4 16.5664C4 15.4664 3.1 14.5664 2 14.5664ZM2 7.56641C0.9 7.56641 0 8.46641 0 9.56641C0 10.6664 0.9 11.5664 2 11.5664C3.1 11.5664 4 10.6664 4 9.56641C4 8.46641 3.1 7.56641 2 7.56641Z",
    fill: "#414141"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavdots);
export default __webpack_public_path__ + "static/media/navdots.d322dde171a62eec86019f8904774bdf.svg";
export { ForwardRef as ReactComponent };